/**
 * 登录页（S04）：邮箱验证码登录。
 *
 * 匿名登录入口已移除：PG 型体验版下匿名身份**能登录但调不了云函数**
 * （网关 403 EXCEED_AUTHORITY，该套餐的「权限控制」页不可配置），
 * 留着按钮只会让人莫名其妙地卡在「新建失败」，见 docs/wiki S06 记录。
 */

import { Button, Card, Form, Input, message, Space, Typography } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function LoginPage() {
  const { sendEmailCode, verifyEmailCode } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/projects";

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const startCountdown = () => {
    setCountdown(60);
    const t = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) clearInterval(t);
        return c - 1;
      });
    }, 1000);
  };

  const onSend = async () => {
    if (!email) return void message.warning("请输入邮箱");
    setSending(true);
    try {
      await sendEmailCode(email);
      message.success("验证码已发送，请查收邮箱");
      startCountdown();
    } catch (e) {
      message.error(`发送失败：${(e as Error).message}`);
    } finally {
      setSending(false);
    }
  };

  const onVerify = async () => {
    if (!code) return void message.warning("请输入验证码");
    setVerifying(true);
    try {
      await verifyEmailCode(email, code);
      message.success("登录成功");
      navigate(from, { replace: true });
    } catch (e) {
      message.error(`登录失败：${(e as Error).message}`);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f5f6f8",
      }}
    >
      <Card style={{ width: 400 }}>
        <Typography.Title level={4} style={{ textAlign: "center" }}>
          ATC 机器人平台
        </Typography.Title>
        <Typography.Paragraph type="secondary" style={{ textAlign: "center" }}>
          邮箱验证码登录
        </Typography.Paragraph>
        <Form layout="vertical">
          <Form.Item label="邮箱">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button onClick={onSend} loading={sending} disabled={countdown > 0}>
                {countdown > 0 ? `${countdown}s` : "获取验证码"}
              </Button>
            </Space.Compact>
          </Form.Item>
          <Form.Item label="验证码">
            <Input
              placeholder="6 位验证码"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onPressEnter={onVerify}
            />
          </Form.Item>
          <Button type="primary" block onClick={onVerify} loading={verifying}>
            登录
          </Button>
        </Form>
      </Card>
    </div>
  );
}
